import React, { useEffect, useState } from "react";
import s from './billLog.module.css';
import {getData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";
import {GreenButton, BlueButton, RedButton} from '../components/MyButton';
import {
  useSearchParams
} from "react-router-dom";
import {modifiedDate} from '../middleware/dateControl';
import {unsecuredCopyToClipboard} from '../middleware/clipboardService';

export default function BillLog() {
	const navigate = useNavigate();
	let [searchParams, setSearchParams] = useSearchParams();
	let id = searchParams.get("id")
	let limit = searchParams.get("limit")
	
	let [billLogs, setBillLogs] = useState([]);
	
	const fetchData = () => {	
		getData('billLogApi/listLog?userId=' + id + '&limit=' + limit, navigate)
			.then(res => {
				setBillLogs(res.data);
			}
		);
	}
	
	useEffect(() => {
		if (id) {
			fetchData();
		}
	}, []);
	
	
	return (<div>
	
		<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
			<div style={{display:"flex"}}>
				<div style={{flex: '0 0 70px'}}>Id</div>
				<div style={{flex: '0 0 70px'}}>AT</div>
				<div style={{flex: '0 0 70px'}}>Type</div>
				<div style={{flex: '0 0 70px'}}>Method</div>
				<div style={{flex: '0 0 70px'}}>Params</div>
			</div>
			{
				billLogs.map((d, indexD) => (<div key={indexD + "billLog"} style={{display:"flex", gap:"10px", margin:"10px", alignItems:"center"}}>
					
					<div>		
						<GreenButton isEnabled={true} clickedAction={()=>{

							unsecuredCopyToClipboard(d.id);
						}} bText={d.id} />
					</div>
					
					<div>
						<GreenButton isEnabled={true} clickedAction={()=>{

							unsecuredCopyToClipboard(d.accessToken);
						}} bText={"Access Token"} />					
					</div>
					<div>
						<GreenButton isEnabled={true} clickedAction={()=>{

							unsecuredCopyToClipboard(d.paramsStr);
						}} bText={"Param"} />					
					</div>
					<div style={{width:"60px", fontWeight:"bold", color:(d.type=='POST') ? "#b84cb8": "#4cb84c"}}>{d.type}</div>
					<div>
						<BlueButton isEnabled={true} clickedAction={()=>{

							unsecuredCopyToClipboard(d.method);
						}} bText={d.method} />			
					
					</div>

					<div style={{whiteSpace:"nowrap",fontWeight:"bold"}}>{modifiedDate(d.createTs)}</div>
					
				</div>))
			}
		
		</div>
	
	</div>);
}

